import React, { useEffect, useState } from 'react';
import DataGrid from '../../../../../table/DataGrid';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonStartIcon from '../../../../../button/ButtonStartIcon';
import InputField from '../../../../../FormControl/input/InputField';
import { Box } from '@mui/material';

const List = ({ isLoading, listTemp, name = 'learning area', permissions, onAction }) => {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState({});

  useEffect(() => {
    setList(listTemp);
  }, [listTemp]);

  const onSearch = (key, value = '') => {
    setFilter({ ...filter, [key]: value });
    if (value.length === 0) {
      setList(listTemp);
    } else {
      const filterData = listTemp.filter(
        (item) =>
          item.name.toLowerCase().includes(value.toLowerCase()) ||
          item?.code?.toLowerCase().includes(value.toLowerCase())
      );
      setList(filterData);
    }
  };

  const columnsTable = [
    {
      show: true,
      key: 'code',
      align: 'center',
      hide: false,
      width: 1,
      label: ''
    },
    {
      show: true,
      key: 'primary',
      align: 'left',
      hide: false,
      width: 200,
      label: 'Name'
    },
    {
      show: permissions['preview'] || permissions['updated'] || permissions['deleted'],
      key: 'actions',
      align: 'center',
      hide: false,
      width: 3,
      label: 'actions'
    }
  ];

  return (
    <>
      <div className='flex gap-2 items-center justify-between items-center py-2'>
        <div className='flex gap-2 justify-start'>
          <ButtonStartIcon
            variant='text'
            startIcon='bars-filter'
            title='Filter'
            color='primary'
            classNameIcon='text-3xl'
            size='large'
          >
            Filter
          </ButtonStartIcon>
          <div className='max-w-250px'>
            <InputField placeholder='Search' onChange={(e) => onSearch('search', e.target.value)} />
          </div>
        </div>
      </div>
      <Box className='px-2 py-2 absolute top-24 bottom-0 inset-x-0'>
        <DataGrid
          id='marking-curriculum'
          showSetting={false}
          rowsPerPage={list?.length || 10}
          rows={list.map((row) => {
            return {
              ...row,
              code: (
                <div className='flex items-center justify-center py-1'>
                  <div
                    className='size-10 flex items-center justify-center bg-muted text-muted-foreground rounded-full'
                    style={{
                      color: row.primaryColor ? row.primaryColor : 'currentcolor',
                      backgroundColor : row.secondaryColor ? row.secondaryColor : 'currentcolor'
                    }}
                  >
                    {row.position}
                  </div>
                </div>
              ),
              primary: (
                <div>
                  <p>{row.name}</p>
                  <p className='text-xs text-muted-foreground opacity-50'>{row.description}</p>
                </div>
              ),
              actions: (
                <div>
                  {permissions['preview'] && (
                    <IconTooltipButton
                      title='Preview'
                      icon='expand-alt'
                      onClick={() => onAction('preview', row)}
                    />
                  )}
                  {permissions['updated'] && (
                    <IconTooltipButton
                      title='Edit'
                      icon={['fas', 'edit']}
                      onClick={() => onAction('edit', row)}
                    />
                  )}
                  {permissions['deleted'] && (
                    <IconTooltipButton
                      title='Delete'
                      icon={['fas', 'trash-alt']}
                      onClick={() => onAction('delete', row)}
                    />
                  )}
                </div>
              )
            };
          })}
          loading={isLoading}
          columns={columnsTable}
          labelNoRows={`You don't have any ${name} yet`}
        />
      </Box>
    </>
  );
};

export default List;
